export const AuctionSummaryModal = ({ handleBack, handleConfirm }) => {
  return (
    <div className="Schedule_new_case_modal_wrapper">
      <div
        style={{
          maxWidth: "560px",
          backgroundImage: "none",
        }}
        className="schedule-form-wrapper"
      >
        <div
          style={{
            position: "relative",
          }}
          className="schedule-form-header"
        >
          <p>Auction Summary</p>
        </div>

        <div
          style={{
            width: "100%",
            padding: "32px  16px",
            position: "relative",
            maxHeight: "80vh",
            overflowY: "scroll",
          }}
          className="sale-form-container"
        >
          <div>
            <p
              style={{
                color: "#282828",
              }}
            >
              <span
                style={{
                  fontWeight: "600",
                  paddingRight: "8px",
                }}
              >
                Suit number:
              </span>
              ID/ADR/1470/2020
            </p>
          </div>
          <div className="commission-summary-container">
            <div className="total-process-wrapper">
              <p>Total Auction Amount</p>
              <p>100,000</p>
            </div>
            <div className="total-process-wrapper">
              <p>Property Type </p>
              <div className="movement-wrapper">
                <p>Movable</p>
                <p
                  style={{
                    fontWeight: "400",
                    fontSize: "12px",
                  }}
                  className="commission-summary-description"
                >
                  3.5% of total auction amount
                </p>
              </div>
            </div>
            <div className="internal-payment-wrapper">
              <p>Internal Payment to chief registrar</p>
            </div>
            <div className="commission-summary-wrapper">
              <div>
                <p className="commission-summary-title">
                  Government Commission
                </p>
                <p className="commission-summary-description">
                  3.5% of total auction amount
                </p>
              </div>
              <p className="commission-summary-amount">3500</p>
            </div>
            <div className="total-process-wrapper">
              <p>Total proceed left</p>
              <p>96,500</p>
            </div>
          </div>
          <div>
            <p style={{ marginBottom: "23px", fontSize: "12px" }}>
              Invoice and receipt of payment will be generated on confirmation
            </p>
            <div
              style={{
                marginTop: "0px",
                justifyContent: "flex-end",
              }}
              className="assign-case-button-group"
            >
              <button
                style={{
                  maxWidth: "132px",
                }}
                type="button"
                onClick={handleBack}
              >
                Back
              </button>
              <button
                style={{
                  maxWidth: "224px",
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
